export default "__VITE_ASSET__Dgb7o$o0__"